import actions from './socket.actions';

const mutations = {
  SOCKET_CONNECT(state) {
    state.connected = true;
  },
  SOCKET_DISCONNECT(state) {
    state.connected = false;
  },
  SOCKET_AUTHORIZED(state, value) {
    state.authorized = value;
  }
};

export { mutations };

export default {
  state: {
    authorized: false,
    connected: false
  },
  mutations,
  actions
};
